import React, { useEffect, useMemo, useState } from 'react';
import { Col, Row, Button, Container } from 'reactstrap';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import renderField from '../../shared/components/custom/Field';
import renderSelectField from '../../shared/components/form/Select';
import validatePaymentOption from './validatePaymentOption';
import renderSwitchField from '../../shared/components/custom/Switch';
import { partial } from '../../util/translation/translation';
import useConfig from '../../util/useConfig';
import { connect } from 'react-redux';
import moment from 'moment';
import clubConfig from '../../config';
import FormBox from '../../shared/components/custom/FormBox';

const PaymentOptionForm = ({
  paymentOption,
  type,
  backUrl,
  handleSubmit,
  initialize,
  formValues,
  change,
  entityType,
}) => {
  const config = useConfig();
  const p = partial('paymentOptions');
  const s = partial('shared');
  const [selectOptionType, setSelectOptionType] = useState(null);
  const providerTypes = [{ label: p('providerType-stripe'), value: 'stripe' }];
  const paymentTypes = [
    { label: p('paymentType-subscription'), value: 'subscription' },
    { label: p('paymentType-one_time'), value: 'one_time' },
  ];
  const vatOptions = [
    entityType === 'goal_subscription' && { label: 0, value: 0 },
    { label: clubConfig.vat, value: clubConfig.vat },
  ];
  const paymentOptionTypes = useMemo(() => {
    if (formValues?.paymentType?.value === 'subscription') {
      const arr = [{ label: p('paymentOptionType-months'), value: 'months' }];
      if (entityType === 'goal_subscription') {
        arr.push({ label: p('paymentOptionType-day'), value: 'days' });
      }
      return arr;
    }
    return [
      { label: p('paymentOptionType-months'), value: 'months' },
      { label: p('paymentOptionType-till_date'), value: 'till_date' },
    ];
  }, [formValues]);
  const isEdit = !!paymentOption;
  const clubVat = clubConfig.vat || 0;
  useEffect(() => {
    if (paymentOption) {
      initialize({
        providerType: {
          value: paymentOption.providerType,
          label: providerTypes.find(
            (type) => type.value === paymentOption.providerType
          ).label,
        },
        paymentType: {
          value: paymentOption.paymentType,
          label: paymentTypes.find(
            (type) => type.value === paymentOption.paymentType
          ).label,
        },
        grossPrice: paymentOption.price / 100,
        vat: vatOptions.find((option) => option.value === paymentOption.vat),
        isActive: !!paymentOption.isActive,
        optionType: {
          value: paymentOption.optionType,
          label: paymentOptionTypes.find(
            (type) => type.value === paymentOption.optionType
          ).label,
        },
        optionValue: paymentOption.optionValue,
        salesEndDate: paymentOption.salesEndDate
          ? moment(paymentOption.salesEndDate).format('YYYY-MM-DD')
          : '',
        badgeText: paymentOption.badgeText || '',
      });
      setSelectOptionType(paymentOption.optionType);
    } else {
      initialize({
        vat: vatOptions.find((option) => option.value === clubVat),
        ...(entityType === 'goal_subscription' && {
          paymentType: {
            value: 'subscription',
            label: p('paymentType-subscription'),
          },
        }),
        ...(entityType === 'goal_subscription' && {
          optionType: {
            value: 'days',
            label: p('paymentOptionType-day'),
          },
        }),
        ...(entityType === 'goal_subscription' && {
          optionValue: 1,
        }),
      });
      if (entityType === 'goal_subscription') {
        setSelectOptionType('days');
      }
    }
  }, [paymentOption]);
  return (
    <form className="form" onSubmit={handleSubmit}>
      <div style={{ width: '100%' }}>
        <div style={{ padding: '10px' }}>
          <Container>
            <Row>
              <Col md={6}>
                <div className="form__form-group">
                  <span className="form-header">{p('providerType')}*</span>
                  <Field
                    name="providerType"
                    placeholder={p('providerType')}
                    options={providerTypes}
                    component={renderSelectField}
                    disabled={isEdit}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className="form__form-group">
                  <span className="form-header">{p('paymentType')}*</span>
                  <Field
                    name="paymentType"
                    component={renderSelectField}
                    options={paymentTypes}
                    placeholder={p('paymentType')}
                    onChange={(e) => {
                      setSelectOptionType(null);
                      change('optionType', null);
                    }}
                    disabled={isEdit || entityType === 'goal_subscription'}
                  />
                </div>
              </Col>
            </Row>
            <FormBox title={p('activityLenght')}>
              <Col>
                <Row>
                  <Col md={6}>
                    <div className="form__form-group">
                      <span className="form-header">
                        {p('activityLenght')}*
                      </span>
                      <Field
                        name="optionType"
                        component={renderSelectField}
                        options={paymentOptionTypes}
                        placeholder={p('activityLenght')}
                        disabled={isEdit || entityType === 'goal_subscription'}
                        onChange={(e) => setSelectOptionType(e.value)}
                      />
                    </div>
                  </Col>
                  {selectOptionType === 'till_date' && (
                    <Col md={6}>
                      <div className="form__form-group">
                        <span className="form-header">
                          {p('optionValueTillDate')}*
                        </span>
                        <Field
                          name="optionValue"
                          component={renderField}
                          type="datetime-local"
                          disabled={isEdit}
                          placeholder={p('optionValueTillDate')}
                        />
                      </div>
                    </Col>
                  )}
                  {selectOptionType === 'months' && (
                    <Col md={6}>
                      <div className="form__form-group">
                        <span className="form-header">
                          {p('optionValueMonths')}*
                        </span>
                        <Field
                          name="optionValue"
                          component={renderField}
                          disabled={isEdit}
                          type="number"
                          placeholder={p('optionValueMonths')}
                        />
                      </div>
                    </Col>
                  )}
                  {selectOptionType === 'days' && (
                    <Col md={6}>
                      <div className="form__form-group">
                        <span className="form-header">
                          {p('optionValueDays')}*
                        </span>
                        <Field
                          name="optionValue"
                          component={renderField}
                          disabled={true}
                          type="number"
                          placeholder={p('optionValueDays')}
                        />
                      </div>
                    </Col>
                  )}
                </Row>
              </Col>
            </FormBox>
            <Row className="mt-2">
              <Col md={4}>
                <div className="form__form-group">
                  <span className="form-header">
                    {p('grossPriceMin')} {5} {config.currencyShortSmall}*
                  </span>
                  <div className="form__form-group-field">
                    <Field
                      name="grossPrice"
                      component={renderField}
                      type="number"
                      min={5}
                      placeholder={p('grossPrice')}
                      disabled={isEdit}
                    />
                    <div className="form__form-group-icon">
                      &nbsp;{config.currencyShortSmall}&nbsp;
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={2}>
                <div className="form__form-group">
                  <span className="form-header">{p('netPrice')}</span>
                  <div className="form__form-group-field">
                    {renderField({
                      input: {
                        value: formValues?.grossPrice
                          ? (
                              (formValues?.grossPrice * 100) /
                              (100 + (formValues?.vat?.value || 0))
                            ).toFixed(2)
                          : p('netPrice'),
                      },
                      meta: {},
                      disabled: true,
                    })}
                    <div className="form__form-group-icon">
                      &nbsp;{config.currencyShortSmall}&nbsp;
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={2}>
                <div className="form__form-group">
                  <span className="form-header">{s('vat')}*</span>
                  <div className="form__form-group-field">
                    <Field
                      name="vat"
                      placeholder={s('vat')}
                      options={vatOptions}
                      component={renderSelectField}
                      disabled={isEdit || entityType !== 'goal_subscription'}
                    />
                    <div className="form__form-group-icon">&nbsp;%&nbsp;</div>
                  </div>
                </div>
              </Col>
            </Row>
            {entityType === 'tier' && (
              <Row>
                <Col md={4}>
                  <div className="form__form-group">
                    <span className="form-header">{p('salesEndDate')}</span>
                    <Field
                      name="salesEndDate"
                      component={renderField}
                      type="date"
                    />
                    <small className="text-muted">
                      {p('salesEndDateInfo')}
                    </small>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form__form-group">
                    <span className="form-header">{p('badgeText')}</span>
                    <Field
                      name="badgeText"
                      component={renderField}
                      maxLength={60}
                      placeholder={p('badgeTextPlaceholder')}
                    />
                    <small className="text-muted">{p('badgeTextInfo')}</small>
                  </div>
                </Col>
              </Row>
            )}
            <Row>
              <Col md={2}>
                <div className="form__form-group flex-Vcenter">
                  <span className="form-header" />
                  <Field
                    name="isActive"
                    component={renderSwitchField}
                    label={[`${s('active')}`, `${s('inActive')}`]}
                    defaultChecked
                    className="colored-click"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <Col>
        <Button color="primary">
          {type === 'create' ? `${s('create')}` : `${s('save')}`}
        </Button>
        <Link to={backUrl}>
          <Button>{s('close')}</Button>
        </Link>
      </Col>
    </form>
  );
};

const reduxF = reduxForm({
  form: 'payment_option_form',
  validate: validatePaymentOption,
});
const mapStateToProps = (state) => ({
  formValues: getFormValues('payment_option_form')(state),
});
export default connect(mapStateToProps)(reduxF(PaymentOptionForm));
